import Flickity from 'flickity';

export default(() => {
    const carousel = document.querySelector('.js-news-carousel');

    if (carousel) {
        const flkty = new Flickity(carousel, {
            cellSelector: '.card',
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            groupCells: '100%',
        });

        const prevBtn = document.querySelector('.js-news-carousel-prev');
        const nextBtn = document.querySelector('.js-news-carousel-next');

        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            flkty.previous();
        });

        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            flkty.next();
        });

        flkty.on('change', (index) => {
            prevBtn.classList.add('iconlink--disabled');
            nextBtn.classList.add('iconlink--disabled');

            if (index) prevBtn.classList.remove('iconlink--disabled');
            if (index + 1 < flkty.slides.length) nextBtn.classList.remove('iconlink--disabled');
        });
    }
})();
